import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useFirestoreConnect } from 'react-redux-firebase'
import { notRelevant } from '../../store/actions/redditActions'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

function handleNotRelevant(dispatch, restaurant, index, notRelevantList, setNotRelevantList){
  //console.log('not relevant')
  //console.log(notRelevantList)
  if(notRelevantList){
    let arr = [...notRelevantList];
    //console.log(arr)
    if(arr.includes(index)){
      arr = arr.filter(itm => itm !== index)
    }
    else{
      arr.push(index)
    }
    //console.log(arr)
  }
  dispatch(notRelevant(restaurant, index))

  
}

function handleThread(thread){
  if(thread){
    window.open('https://www.reddit.com' + thread);
  }
  else{
    alert("Sorry, some reddit comments don't have links")
  }
}

function Reddit(props) {

  const userId = useSelector((state)=>state.firebase.auth.uid);

  useFirestoreConnect([
    { 
    collection: 'reddit',
      doc: props.restaurant.replace('/',''),
     },
    {
    collection: 'redditNotRelevant',
      doc: userId
    }
  ])

  const dispatch = useDispatch();

  
  const restaurants = useSelector((state)=>state.firestore.data.restaurants)
  const redditCount = useSelector((state)=>state.firestore.ordered.redditCount)
  
  const redditNotRelevant = useSelector(
    ({ firestore: { data } }) => data.redditNotRelevant && data.redditNotRelevant[userId]
  );

  const data = useSelector(
    ({ firestore: { data } }) => data.reddit && data.reddit[props.restaurant.replace('/','')]
  );

  const [testData, setTestData] = useState(false);

  const [finalData, setFinalData] = useState(false);

  const restaurant = props.restaurant.replace('/','');

  const [parsedDates, setParsedDates] = useState(false);

  const [loading, setLoading] = useState(true);

  const [count, setCount] = useState(false);

  const [showNumber, setShowNumber] = useState(10);

  const [notRelevantList, setNotRelevantList] = useState([])

  useEffect(()=>{
    if(redditCount && !count){
      setCount(redditCount[0]['countDict'][props.restaurant.replace('/','')])
    }
  },[redditCount])

  useEffect(()=>{
    if(redditNotRelevant && redditNotRelevant[props.restaurant.replace('/','')] && JSON.stringify(redditNotRelevant[props.restaurant.replace('/','')]) !== JSON.stringify(notRelevantList)){
      setNotRelevantList([...redditNotRelevant[props.restaurant.replace('/','')]])
    }
    if(document.getElementById('notRel1') && document.getElementById('notRel1').style){
      document.getElementById('notRel1').style.display = 'block';  
    }
    if(document.getElementById('notRel2') && document.getElementById('notRel2').style){
      document.getElementById('notRel2').style.display = 'block';  
    }
    
  },[redditNotRelevant])


  useEffect(()=>{

    if(data){
      setLoading(false);
      let dates = Object.entries(data['created']);
      let endDates = [];
      for(let date in dates){
        let thisDate = new Date(dates[date][1]*1000);
        let dateString = thisDate.toString()
        endDates.push(dateString.slice(0,-32))
      }
      setParsedDates(endDates);

      let testData2 = Object.entries(data['created']).sort(function(a, b) {
      return b[1] - a[1];
      });  

      setTestData(testData2)
    }
    
  },[data])


  return (
    <div>
      {
        loading &&
        <p>{ 'loading...' }</p>
      }
      {
        !loading && count !== false &&
        <p>{ count + ' comments' }</p>
      }
      { data && parsedDates && testData &&
        
        Object.entries(data['body']).slice(0,showNumber).map( (itm, index) => {
        return(

        <div key={parseInt(testData[index][0]) + 'top'} id={"top"}>
        { notRelevantList && notRelevantList.includes(parseInt(testData[index][0])) &&
          <div key={parseInt(testData[index][0])}>
            <p>{Object.entries(data['author'])[parseInt(testData[index][0])][1]}</p>
            <p>{parsedDates[parseInt(testData[index][0])] && parsedDates[parseInt(testData[index][0])]}</p>
            <div style={{textAlign:'left', textDecoration: 'line-through', textDecorationColor: "red"}}>
              <ReactMarkdown children = {data['body'][parseInt(testData[index][0])]} remarkPlugins={[remarkGfm]}/>
            </div>
            {/*<a href={'https://www.reddit.com' + Object.entries(data['permalink'])[parseInt(testData[index][0])][1]} target="_blank">link</a>*/}
            <div style={{display:'flex', justifyContent:'space-between'}}>
              <button className="btn" style={{backgroundColor:'#ff4500'}} onClick={()=>{handleThread(Object.entries(data['permalink'])[parseInt(testData[index][0])][1])}}>See Thread</button>
              <button id="notRel1" className="btn" style={{backgroundColor:'#ff4500'}} onClick={()=>{document.getElementById('notRel1').style.display = 'none'; handleNotRelevant(dispatch, props.restaurant.replace('/',''), parseInt(testData[index][0]), notRelevantList, setNotRelevantList)}}>Relevant</button>
            </div>
            <hr/>
          </div>
        }
        { !(notRelevantList && notRelevantList.includes(parseInt(testData[index][0]))) &&
          <div key={parseInt(testData[index][0])}>
            <p>{Object.entries(data['author'])[parseInt(testData[index][0])][1]}</p>
            <p>{parsedDates[parseInt(testData[index][0])] && parsedDates[parseInt(testData[index][0])]}</p>
            <div style={{textAlign:'left'}}>
              <ReactMarkdown children = {data['body'][parseInt(testData[index][0])]} remarkPlugins={[remarkGfm]}/>
            </div>
            {/*<a href={'https://www.reddit.com' + Object.entries(data['permalink'])[parseInt(testData[index][0])][1]} target="_blank">link</a>*/}
            <div style={{display:'flex', justifyContent:'space-between'}}>
              <button className="btn" style={{backgroundColor:'#ff4500'}} onClick={()=>{handleThread(Object.entries(data['permalink'])[parseInt(testData[index][0])][1])}}>See Thread</button>
              <button id="notRel2" className="btn" style={{backgroundColor:'#7193ff'}} onClick={()=>{document.getElementById('notRel2').style.display = 'none'; handleNotRelevant(dispatch, props.restaurant.replace('/',''), parseInt(testData[index][0]), notRelevantList, setNotRelevantList)}}>Not Relevant</button>
            </div>
            <hr/>
          </div>
        }
        </div>
          )

      })
      }
      { data && data['body'] && showNumber < Object.entries(data['body']).length &&
        <button className="btn pink lighten-1" onClick={()=>{setShowNumber(showNumber+10)}}>Show More</button>          
      }  
    </div>
  );
}

export default Reddit;